export default "__VITE_ASSET__BIJSvvNw__"